var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy link"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 96"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 17",
    cx: 39.3922,
    cy: 39.4729,
    rx: 38.8243,
    ry: 38.8243,
    fill: "#FF4500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5608 46.2064C39.4904 46.1808 39.4202 46.1542 39.3503 46.1266C38.5205 45.806 37.7229 45.3249 37.012 44.6969C36.8879 44.5873 36.766 44.4727 36.6475 44.3542L40.0813 40.9204L36.6475 44.3542C37.445 45.1519 38.3755 45.75 39.3503 46.1266C39.4202 46.1542 39.4904 46.1808 39.5608 46.2064ZM43.8114 41.4862C44.0876 41.341 44.3467 41.1524 44.5787 40.9204H44.5787C44.3467 41.1524 44.0876 41.341 43.8114 41.4862ZM51.2249 34.2741H51.2249C52.4656 33.0335 52.4656 31.0175 51.2249 29.7769C50.9148 29.4667 50.5562 29.2341 50.1733 29.079C50.5561 29.2341 50.9148 29.4667 51.2249 29.7769C52.4656 31.0175 52.4656 33.0335 51.2249 34.2741ZM43.5375 32.967C42.7898 32.6181 42.0016 32.3782 41.1974 32.2462C42.0016 32.3782 42.7898 32.6181 43.5375 32.967L43.5375 32.967ZM37.1571 32.4796L43.2939 26.343C45.2462 24.3907 47.9774 23.6585 50.5138 24.1466C47.9773 23.6585 45.2462 24.3906 43.2938 26.343L37.1571 32.4797C37.1571 32.4797 37.1571 32.4796 37.1571 32.4796ZM47.6409 44.0198C47.4726 44.2068 47.2595 44.3829 47.0369 44.5609C44.8755 46.2643 42.0074 46.6384 39.534 45.6615L39.5305 45.6602C38.7656 45.3646 38.0272 44.9217 37.3662 44.3426L40.1053 41.6036C41.5471 42.6998 43.6163 42.5899 44.9323 41.2739L51.5785 34.6277C53.0144 33.1918 53.0144 30.8592 51.5785 29.4233C50.1426 27.9874 47.81 27.9874 46.3741 29.4233L43.4266 32.3709C41.9185 31.7354 40.2735 31.5085 38.6638 31.6801L43.6474 26.6965C46.5759 23.7681 51.3769 23.7681 54.3053 26.6965C57.2566 29.6478 57.2548 34.4257 54.3065 37.3531L47.6497 44.0099L47.6409 44.0198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6279 50.5786L38.4531 47.7534C39.5968 48.2009 40.4261 48.4691 41.3198 48.5333C41.8969 48.5748 42.4875 48.5303 43.194 48.4127L38.3548 53.3055L38.3538 53.3065C35.4252 56.234 30.625 56.2336 27.6968 53.3055C24.7684 50.377 24.7684 45.5759 27.6968 42.6475L34.3431 36.0013C34.4354 35.909 34.5266 35.8185 34.612 35.7502L34.6228 35.7416L34.6332 35.7323C36.815 33.779 39.8698 33.3012 42.466 34.3397L42.4716 34.3419C43.2365 34.6374 43.9748 35.0803 44.6358 35.6594L41.8968 38.3984C40.455 37.3022 38.3858 37.4121 37.0698 38.7281L30.4235 45.3743C28.9877 46.8102 28.9876 49.1428 30.4235 50.5786C31.8594 52.0146 34.192 52.0146 35.6279 50.5786Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy_link.2e9d4c3060e6c345229d36d7388818cb.svg";
export { ForwardRef as ReactComponent };